<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import countTo from "vue-count-to";
import Statistics from "@/services/Statistics";
import appConfig from "@/app.config";

export default {
  page: {
    title: "Devices",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    countTo,
  },
  data() {
    return {
      title: "Devices",
      items: [
        { text: "CRM" },
        { text: "Devices", active: true },
      ],
      loaderDevices: true,
      totalDevices: 0,
      totalDevicesLast30: 0,
      linkedDevices: 0,
      linkedDevicesLast30: 0,
      iosDevices: 0,
      iosDevicesLast30: 0,
      androidDevices: 0,
      androidDevicesLast30: 0,
      otherDevices: 0,
      otherDevicesLast30: 0,
      devicesByOsSeries: [],
      devicesByOsLabels: [],
      devicesByOsTotal: 0,
      devicesByOsUniqueVersions: 0,
      loaderDevicesByOs: false,
      devicesByPlatformSeries: [],
      devicesByPlatformChartOptions: {
        chart: {
          type: "pie",
          height: 320,
          toolbar: { show: false },
        },
        noData: {
          text: "No data available",
          align: "center",
          verticalAlign: "middle",
          style: { color: "#6c757d", fontSize: "16px" },
        },
        labels: ["iOS", "Android", "Others"],
        colors: ["#a855f7", "#10b981", "#64748b"],
        legend: { position: "bottom", showForZeroSeries: true },
        dataLabels: {
          enabled: true,
          formatter: function (val, opts) {
            const label = opts.w.globals.labels[opts.seriesIndex];
            const count = opts.w.globals.series[opts.seriesIndex];
            return `${label}: ${count} (${val.toFixed(1)}%)`;
          },
        },
        tooltip: {
          y: { formatter: (val) => val },
        },
      },
      devicesByOsChartOptions: {
        chart: {
          width: "100%",
          height: 320,
          parentHeightOffset: 0,
          type: "bar",
          stacked: false,
          toolbar: { show: false },
        },
        noData: {
          text: "No data available",
          align: "center",
          verticalAlign: "middle",
          style: { color: "#6c757d", fontSize: "16px" },
        },
        plotOptions: {
          bar: {
            columnWidth: "85%",
            horizontal: false,
            // borderRadius: 10,
            // borderRadiusApplication: "around",
            // borderRadiusWhenStacked: "last",
            distributed: false,
            endingShape: "rounded",
          },
        },
        stroke: { width: 0, curve: "smooth" },
        dataLabels: { enabled: false },
        fill: { opacity: 1 },
        colors: ["#3b82f6"],
        markers: { size: 0 },
        xaxis: {
          labels: {
            style: {
              fontSize: "12px",
              fontFamily: "Helvetica, Arial, sans-serif",
              fontWeight: 400,
              cssClass: "apexcharts-xaxis-label",
            },
          },
          type: "category",
          categories: [],
        },
        yaxis: {
          title: { text: "" },
          labels: {
            formatter: function (val) {
              return val ? val.toFixed(0) : "0";
            },
          },
          min: 0,
          max: undefined,
        },
        tooltip: {
          shared: false,
          intersect: true,
          y: {
            formatter: function (y) {
              return typeof y !== "undefined" ? y.toFixed(0) : y;
            },
          },
        },
        grid: {
          borderColor: "#f1f3fa",
          strokeDashArray: 3,
          yaxis: { lines: { show: true } },
          xaxis: { lines: { show: false } },
        },
      },
      androidDevicesByOsSeries: [],
      androidDevicesByOsTotal: 0,
      loaderAndroidDevicesByOs: false,
      androidDevicesByOsChartOptions: {
        chart: { width: "100%", height: 320, parentHeightOffset: 0, type: "bar", stacked: false, toolbar: { show: false } },
        noData: { text: "No data available", align: "center", verticalAlign: "middle", style: { color: "#6c757d", fontSize: "16px" } },
        plotOptions: { bar: { columnWidth: "85%", horizontal: false, distributed: false, endingShape: "rounded" } },
        stroke: { width: 0, curve: "smooth" },
        dataLabels: { enabled: false },
        fill: { opacity: 1 },
        colors: ["#10b981"],
        markers: { size: 0 },
        xaxis: { labels: { style: { fontSize: "12px", fontFamily: "Helvetica, Arial, sans-serif", fontWeight: 400, cssClass: "apexcharts-xaxis-label" } }, type: "category", categories: [] },
        yaxis: { title: { text: "" }, labels: { formatter: (val) => (val ? val.toFixed(0) : "0") }, min: 0, max: undefined },
        tooltip: { shared: false, intersect: true, y: { formatter: (y) => (typeof y !== "undefined" ? y.toFixed(0) : y) } },
        grid: { borderColor: "#f1f3fa", strokeDashArray: 3, yaxis: { lines: { show: true } }, xaxis: { lines: { show: false } } },
      },
      iosDevicesByOsSeries: [],
      iosDevicesByOsTotal: 0,
      loaderIosDevicesByOs: false,
      iosDevicesByOsChartOptions: {
        chart: { width: "100%", height: 320, parentHeightOffset: 0, type: "bar", stacked: false, toolbar: { show: false } },
        noData: { text: "No data available", align: "center", verticalAlign: "middle", style: { color: "#6c757d", fontSize: "16px" } },
        plotOptions: { bar: { columnWidth: "85%", horizontal: false, distributed: false, endingShape: "rounded" } },
        stroke: { width: 0, curve: "smooth" },
        dataLabels: { enabled: false },
        fill: { opacity: 1 },
        colors: ["#a855f7"],
        markers: { size: 0 },
        xaxis: { labels: { style: { fontSize: "12px", fontFamily: "Helvetica, Arial, sans-serif", fontWeight: 400, cssClass: "apexcharts-xaxis-label" } }, type: "category", categories: [] },
        yaxis: { title: { text: "" }, labels: { formatter: (val) => (val ? val.toFixed(0) : "0") }, min: 0, max: undefined },
        tooltip: { shared: false, intersect: true, y: { formatter: (y) => (typeof y !== "undefined" ? y.toFixed(0) : y) } },
        grid: { borderColor: "#f1f3fa", strokeDashArray: 3, yaxis: { lines: { show: true } }, xaxis: { lines: { show: false } } },
      },
    };
  },
  async mounted() {
    await this.getDeviceStats();
    this.getDeviceCountByAppVersion();
    this.getAndroidDevicesByOs();
    this.getIosDevicesByOs();
  },
  methods: {
    async getDeviceStats() {
      this.loaderDevices = true;
      try {
        const [totalRes, linkedRes, platformRes] = await Promise.all([
          Statistics.getDeviceTotalCount(),
          Statistics.getDeviceLinkedCount(),
          Statistics.getDeviceCountByPlatform(),
        ]);

        this.totalDevices = totalRes?.data?.data?.total_devices ?? 0;
        this.totalDevicesLast30 = totalRes?.data?.data?.last_30_days ?? 0;
        this.linkedDevices = linkedRes?.data?.data?.linked_devices ?? 0;
        this.linkedDevicesLast30 = linkedRes?.data?.data?.last_30_days ?? 0;
        this.iosDevices = platformRes?.data?.data?.ios_devices ?? 0;
        this.iosDevicesLast30 = platformRes?.data?.data?.ios_devices_last_30_days ?? 0;
        this.androidDevices = platformRes?.data?.data?.android_devices ?? 0;
        this.androidDevicesLast30 = platformRes?.data?.data?.android_devices_last_30_days ?? 0;
        this.otherDevices = platformRes?.data?.data?.others_devices ?? 0;
        this.otherDevicesLast30 = platformRes?.data?.data?.others_devices_last_30_days ?? 0;
        this.devicesByPlatformSeries = [this.iosDevices, this.androidDevices, this.otherDevices];
      } catch (error) {
        this.totalDevices = 0;
        this.totalDevicesLast30 = 0;
        this.linkedDevices = 0;
        this.linkedDevicesLast30 = 0;
        this.iosDevices = 0;
        this.iosDevicesLast30 = 0;
        this.androidDevices = 0;
        this.androidDevicesLast30 = 0;
        this.otherDevices = 0;
        this.otherDevicesLast30 = 0;
        this.devicesByPlatformSeries = [0, 0, 0];
      } finally {
        this.loaderDevices = false;
      }
    },
    async getDeviceCountByAppVersion() {
      this.loaderDevicesByOs = true;
      try {
        const res = await Statistics.getDeviceCountByAppVersion();
        const apiData = res?.data?.data ?? {};
        const seriesData = apiData.data ?? [];
        const labels = apiData.labels ?? [];

        this.devicesByOsSeries = seriesData;
        this.devicesByOsLabels = labels;
        this.devicesByOsTotal = seriesData[0]?.data?.reduce((a, b) => a + b, 0) ?? 0;
        this.devicesByOsUniqueVersions = labels.length;

        const yaxisUpdate = {};
        if (seriesData[0]?.data?.length) {
          const maxVal = Math.max(...seriesData[0].data);
          yaxisUpdate.max = Math.ceil(maxVal * 1.1);
        }

        this.devicesByOsChartOptions = {
          ...this.devicesByOsChartOptions,
          xaxis: {
            ...this.devicesByOsChartOptions.xaxis,
            categories: labels,
          },
          yaxis: {
            ...this.devicesByOsChartOptions.yaxis,
            ...yaxisUpdate,
          },
        };
      } catch (error) {
        this.devicesByOsSeries = [];
        this.devicesByOsLabels = [];
        this.devicesByOsTotal = 0;
        this.devicesByOsUniqueVersions = 0;
      } finally {
        this.loaderDevicesByOs = false;
      }
    },
    async getAndroidDevicesByOs() {
      this.loaderAndroidDevicesByOs = true;
      try {
        const res = await Statistics.getDeviceCountByOsByPlatform("android");
        const apiData = res?.data?.data ?? {};
        const seriesData = apiData.data ?? [];
        const labels = apiData.labels ?? [];

        this.androidDevicesByOsSeries = seriesData;
        this.androidDevicesByOsTotal = seriesData[0]?.data?.reduce((a, b) => a + b, 0) ?? 0;

        const yaxisUpdate = {};
        if (seriesData[0]?.data?.length) {
          const maxVal = Math.max(...seriesData[0].data);
          yaxisUpdate.max = Math.ceil(maxVal * 1.1);
        }

        this.androidDevicesByOsChartOptions = {
          ...this.androidDevicesByOsChartOptions,
          xaxis: { ...this.androidDevicesByOsChartOptions.xaxis, categories: labels },
          yaxis: { ...this.androidDevicesByOsChartOptions.yaxis, ...yaxisUpdate },
        };
      } catch (error) {
        this.androidDevicesByOsSeries = [];
        this.androidDevicesByOsTotal = 0;
      } finally {
        this.loaderAndroidDevicesByOs = false;
      }
    },
    async getIosDevicesByOs() {
      this.loaderIosDevicesByOs = true;
      try {
        const res = await Statistics.getDeviceCountByOsByPlatform("ios");
        const apiData = res?.data?.data ?? {};
        const seriesData = apiData.data ?? [];
        const labels = apiData.labels ?? [];

        this.iosDevicesByOsSeries = seriesData;
        this.iosDevicesByOsTotal = seriesData[0]?.data?.reduce((a, b) => a + b, 0) ?? 0;

        const yaxisUpdate = {};
        if (seriesData[0]?.data?.length) {
          const maxVal = Math.max(...seriesData[0].data);
          yaxisUpdate.max = Math.ceil(maxVal * 1.1);
        }

        this.iosDevicesByOsChartOptions = {
          ...this.iosDevicesByOsChartOptions,
          xaxis: { ...this.iosDevicesByOsChartOptions.xaxis, categories: labels },
          yaxis: { ...this.iosDevicesByOsChartOptions.yaxis, ...yaxisUpdate },
        };
      } catch (error) {
        this.iosDevicesByOsSeries = [];
        this.iosDevicesByOsTotal = 0;
      } finally {
        this.loaderIosDevicesByOs = false;
      }
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <!-- 4 Device Stats Cards -->
    <div class="row">
      <div class="col-md-6 col-xl-3" style="margin-top: 0px;">
        <div class="card">
          <div class="card-body elementPointed">
            <div class="d-flex justify-content-between align-items-start mb-3">             
                <span class="text-muted" style="font-size: 1rem;">Total Devices</span>
                <div
                    class="d-flex justify-content-center align-items-center"
                    style="width: 36px; height: 36px; border-radius: 12px; background-color: #e6f0ff;"
                  >
                      <!-- <h4 class="stats-value mb-0">
                        <span v-if="!loaderDevices">
                          <countTo :startVal="0" :endVal="totalDevices" :duration="2000"></countTo>
                        </span>
                        <b-spinner v-else large></b-spinner>
                      </h4> -->
                      <i class="fas fa-mobile-alt stats-icon" style="color: #3b82f6; font-size: 1.1rem;"></i>
                </div>
            </div>
            <div class="mb-1">
              <h4 class="mb-0" style="font-weight: 400;">
                <span data-plugin="counterup">
                  <countTo
                    :startVal="0"
                    :endVal="totalDevices"
                    :duration="2000"
                  ></countTo>
                </span>
                <span> devices</span>
              </h4>
            </div>
            <p
              class="mt-2 mb-0"
              :class="totalDevicesLast30 >= 0 ? 'text-success' : 'text-danger'"
              style="font-size: 0.9rem;"
            >
            {{ totalDevicesLast30 >= 0 ? '+' + totalDevicesLast30 : totalDevicesLast30 }}
              in last 30 days
            </p>
          </div>
        </div>
      </div>

      <div class="col-md-6 col-xl-3" style="margin-bottom: 0px;">
        <div class="card">
          <div class="card-body elementPointed">
            <div class="d-flex justify-content-between align-items-start mb-3">
                <span class="text-muted" style="font-size: 1rem;">Linked Devices</span>
                <div
                    class="d-flex justify-content-center align-items-center"
                    style="width: 36px; height: 36px; border-radius: 12px; background-color: #ecfdf5;"
                  >
                      <i class="fas fa-link stats-icon" style="color: #22c55e; font-size: 1.1rem;"></i>
                </div>
            </div>
            <div class="mb-1">
              <h4 class="mb-0" style="font-weight: 400;">
                <span data-plugin="counterup">
                  <countTo
                    :startVal="0"
                    :endVal="linkedDevices"
                    :duration="2000"
                  ></countTo>
                </span>
                <span> devices</span>
              </h4>
            </div>
            <p
              class="mt-2 mb-0"
              :class="linkedDevicesLast30 >= 0 ? 'text-success' : 'text-danger'"
              style="font-size: 0.9rem;"
            >
            {{ linkedDevicesLast30 >= 0 ? '+' + linkedDevicesLast30 : linkedDevicesLast30 }}
              in last 30 days
            </p>
          </div>
        </div>
      </div>

      <div class="col-md-6 col-xl-3" style="margin-bottom: 0px;">
        <div class="card">
          <div class="card-body elementPointed">
            <div class="d-flex justify-content-between align-items-start mb-3">
                <span class="text-muted" style="font-size: 1rem;">iOS Devices</span>
                <div
                    class="d-flex justify-content-center align-items-center"
                    style="width: 36px; height: 36px; border-radius: 12px; background-color: #f5f3ff;"
                  >
                      <i class="fab fa-apple stats-icon" style="color: #a855f7; font-size: 1.1rem;"></i>
                </div>
            </div>
            <div class="mb-1">
              <h4 class="mb-0" style="font-weight: 400;">
                <span data-plugin="counterup">
                  <countTo
                    :startVal="0"
                    :endVal="iosDevices"
                    :duration="2000"
                  ></countTo>
                </span>
                <span> devices</span>
              </h4>
            </div>
            <p
              class="mt-2 mb-0"
              :class="iosDevicesLast30 >= 0 ? 'text-success' : 'text-danger'"
              style="font-size: 0.9rem;"
            >
            {{ iosDevicesLast30 >= 0 ? '+' + iosDevicesLast30 : iosDevicesLast30 }}
              in last 30 days
            </p>
          </div>
        </div>
      </div>

      <div class="col-md-6 col-xl-3" style="margin-bottom: 0px;">
        <div class="card">
          <div class="card-body elementPointed">
            <div class="d-flex justify-content-between align-items-start mb-3">
                <span class="text-muted" style="font-size: 1rem;">Android Devices</span>
                <div
                    class="d-flex justify-content-center align-items-center"
                    style="width: 36px; height: 36px; border-radius: 12px; background-color: #ecfdf5;"
                  >
                      <i class="fab fa-android stats-icon" style="color: #10b981; font-size: 1.1rem;"></i>
                </div>
            </div>
            <div class="mb-1">
              <h4 class="mb-0" style="font-weight: 400;">
                <span data-plugin="counterup">
                  <countTo
                    :startVal="0"
                    :endVal="androidDevices"
                    :duration="2000"
                  ></countTo>
                </span>
                <span> devices</span>
              </h4>
            </div>
            <p
              class="mt-2 mb-0"
              :class="androidDevicesLast30 >= 0 ? 'text-success' : 'text-danger'"
              style="font-size: 0.9rem;"
            >
            {{ androidDevicesLast30 >= 0 ? '+' + androidDevicesLast30 : androidDevicesLast30 }}
              in last 30 days
            </p>
          </div>
        </div>
      </div>

      <!-- Old card blocks removed -->
    </div>

    <!-- Devices by App Version & Devices by Platform -->
    <div class="row mt-4">
      <div class="col-12 col-md-6">
        <div class="card h-100 devices-os-card">
          <div class="card-body d-flex flex-column">
            <div class="d-flex justify-content-between align-items-center mb-0">
              <span class="h5 ms-3 mb-0">Devices by App Version</span>
            </div>
            <div class="d-flex justify-content-between mt-3">
              <p class="text-muted ms-3 mb-1" style="font-size: 0.9rem;">
                Total devices
              </p>
              <p class="text-muted ms-3 mb-1" style="font-size: 0.9rem;">
                Unique versions
              </p>
            </div>
            <div class="d-flex justify-content-between align-items-baseline ms-3 mb-1" style="gap: 8px;">
              <span style="font-size: 1.6rem; font-weight: 400;">
                {{ devicesByOsTotal.toLocaleString() }}
              </span>
              <span style="font-size: 1.6rem; font-weight: 400;">
                {{ devicesByOsUniqueVersions }}
              </span>
            </div>
            <div class="flex-grow-1" style="min-height: 0;">
              <apexchart
                v-if="!loaderDevicesByOs"
                id="devicesByOsChart"
                height="320"
                data-colors='["#3b82f6"]'
                class="apex-charts"
                ref="devicesByOsChart"
                :options="devicesByOsChartOptions"
                :series="devicesByOsSeries"
              >
              </apexchart>
              <div class="col-12 mt-5 d-flex align-items-center justify-content-center" v-else>
                <b-spinner large></b-spinner>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Devices by Platform (device_platform) - Pie Chart -->
      <div class="col-12 col-md-6">
        <div class="card h-100 devices-os-card">
          <div class="card-body d-flex flex-column">
            <div class="d-flex justify-content-between align-items-center mb-0">
              <span class="h5 ms-3 mb-0">Devices by Platform</span>
            </div>
            <div class="d-flex justify-content-between mt-3">
              <p class="text-muted ms-3 mb-1" style="font-size: 0.9rem;">
                iOS:
              </p>
              <p class="text-muted ms-3 mb-1" style="font-size: 0.9rem;">
                Android: 
              </p>
              <p class="text-muted ms-3 mb-1" style="font-size: 0.9rem;">
                Others:  
              </p>
            </div>
            <div class="d-flex justify-content-between align-items-baseline ms-3 mb-1" style="gap: 8px;">
              <span style="font-size: 1.6rem; font-weight: 400;">
                {{ iosDevices.toLocaleString() }}
              </span>
              <span style="font-size: 1.6rem; font-weight: 400; padding-right: 82px;">
               {{ androidDevices.toLocaleString() }}
              </span>
              <span style="font-size: 1.6rem; font-weight: 400;">
               {{ otherDevices.toLocaleString() }}
              </span>
            </div>
            <div class="flex-grow-1" style="min-height: 0;">
              <apexchart
                v-if="!loaderDevices"
                id="devicesByPlatformChart"
                type="pie"
                height="320"
                data-colors='["#a855f7", "#10b981", "#64748b"]'
                class="apex-charts"
                ref="devicesByPlatformChart"
                :options="devicesByPlatformChartOptions"
                :series="devicesByPlatformSeries"
              >
              </apexchart>
              <div class="col-12 mt-5 d-flex align-items-center justify-content-center" v-else>
                <b-spinner large></b-spinner>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Android device_os & iOS device_os -->
    <div class="row mt-4">
      <div class="col-12 col-md-6">
        <div class="card h-100 devices-os-card">
          <div class="card-body d-flex flex-column">
            <div class="d-flex justify-content-between align-items-center mb-0">
              <span class="h5 ms-3 mb-0">Android - Devices by OS</span>
            </div>
            <div class="d-flex justify-content-between mt-3">
              <p class="text-muted ms-3 mb-1" style="font-size: 0.9rem;">Total devices</p>
            </div>
            <div class="d-flex justify-content-between align-items-baseline ms-3 mb-1">
              <span style="font-size: 1.6rem; font-weight: 400;">{{ androidDevicesByOsTotal.toLocaleString() }}</span>
            </div>
            <div class="flex-grow-1" style="min-height: 0;">
              <apexchart
                v-if="!loaderAndroidDevicesByOs"
                id="androidDevicesByOsChart"
                height="320"
                data-colors='["#10b981"]'
                class="apex-charts"
                :options="androidDevicesByOsChartOptions"
                :series="androidDevicesByOsSeries"
              ></apexchart>
              <div class="col-12 mt-5 d-flex align-items-center justify-content-center" v-else>
                <b-spinner large></b-spinner>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-6">
        <div class="card h-100">
          <div class="card-body d-flex flex-column">
            <div class="d-flex justify-content-start align-items-center mb-0">
              <span class="h5 ms-3 mb-0">iOS - Devices by OS</span>
            </div>
            <div class="d-flex justify-content-between mt-3">
              <p class="text-muted ms-3 mb-1" style="font-size: 0.9rem;">Total devices</p>
            </div>
            <div class="d-flex justify-content-between align-items-baseline ms-3 mb-1">
              <span style="font-size: 1.6rem; font-weight: 400;">{{ iosDevicesByOsTotal.toLocaleString() }}</span>
            </div>
            <div class="flex-grow-1" style="min-height: 0;">
              <apexchart
                v-if="!loaderIosDevicesByOs"
                id="iosDevicesByOsChart"
                height="320"
                data-colors='["#a855f7"]'
                class="apex-charts"
                :options="iosDevicesByOsChartOptions"
                :series="iosDevicesByOsSeries"
              ></apexchart>
              <div class="col-12 mt-5 d-flex align-items-center justify-content-center" v-else>
                <b-spinner large></b-spinner>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
.card {
    border-radius: 10px;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
    margin-bottom: 0 !important;
  }
  
  /* Ensure equal height cards with flexbox */
  .row.d-flex > [class*="col-"] {
    display: flex;
    align-items: stretch;
  }
  
  .row.d-flex > [class*="col-"] > .card {
    display: flex;
    flex: 1;
    width: 100%;
    align-items: stretch;
  }
  
  .card-body.d-flex.flex-column {
    min-height: 100%;
    flex: 1;
    display: flex;
    flex-direction: column;
  }
  
  .card-body.d-flex.flex-column > * {
    flex-shrink: 0;
  }
  
  .card-body.d-flex.flex-column .flex-grow-1 {
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
    min-height: 0;
  }
  
  .card-body.d-flex.flex-column .apex-charts {
    flex: 1;
    min-height: 0;
  }
  .card-title {
    font-weight: 500;
  }

.stats-card {
  position: relative !important;
  border: none !important;
  border-radius: 20px !important;
  background: linear-gradient(145deg, #ffffff 0%, #fafafa 100%) !important;
  /* box-shadow: 0 10px 30px -5px rgba(0, 0, 0, 0.08), 0 0 0 1px rgba(0, 0, 0, 0.02) !important; */
  transition: all 0.3s ease !important;
  overflow: hidden !important;
}

.stats-card:hover {
  transform: translateY(-5px) !important;
}

.stats-card--total:hover {
  box-shadow: 0 20px 40px -8px rgba(0, 0, 0, 0.12), 0 0 0 1px rgba(59, 130, 246, 0.2) !important;
}

.stats-card--linked:hover {
  box-shadow: 0 20px 40px -8px rgba(0, 0, 0, 0.12), 0 0 0 1px rgba(34, 197, 94, 0.2) !important;
}

.stats-card--ios:hover {
  box-shadow: 0 20px 40px -8px rgba(0, 0, 0, 0.12), 0 0 0 1px rgba(168, 85, 247, 0.2) !important;
}

.stats-card--android:hover {
  box-shadow: 0 20px 40px -8px rgba(0, 0, 0, 0.12), 0 0 0 1px rgba(16, 185, 129, 0.2) !important;
}

.stats-label {
  font-size: 0.9rem !important;
  font-weight: 500 !important;
  color: #64748b !important;
  letter-spacing: 0.3px !important;
  text-transform: uppercase !important;
}

.stats-value-wrapper {
  margin-top: 8px !important;
}

.stats-value {
  font-size: 2.2rem !important;
  font-weight: 600 !important;
  color: #1e293b !important;
  line-height: 1.2 !important;
  background: linear-gradient(135deg, #1e293b 0%, #0f172a 100%) !important;
  background-clip: text !important;
  -webkit-background-clip: text !important;
  -webkit-text-fill-color: transparent !important;
}

.stats-icon-wrapper {
  width: 48px !important;
  height: 48px !important;
  border-radius: 16px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  transition: all 0.3s ease !important;
}

.stats-card--total .stats-icon-wrapper {
  background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%) !important;
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.15) !important;
}

.stats-card--total:hover .stats-icon-wrapper {
  background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%) !important;
  box-shadow: 0 8px 16px rgba(59, 130, 246, 0.25) !important;
}

.stats-card--total .stats-icon {
  color: #3b82f6 !important;
}

.stats-card--total:hover .stats-icon {
  color: #ffffff !important;
}

.stats-card--linked .stats-icon-wrapper {
  background: linear-gradient(135deg, #ecfdf5 0%, #dcfce7 100%) !important;
  box-shadow: 0 4px 12px rgba(34, 197, 94, 0.15) !important;
}

.stats-card--linked:hover .stats-icon-wrapper {
  background: linear-gradient(135deg, #22c55e 0%, #16a34a 100%) !important;
  box-shadow: 0 8px 16px rgba(34, 197, 94, 0.25) !important;
}

.stats-card--linked .stats-icon {
  color: #22c55e !important;
}

.stats-card--linked:hover .stats-icon {
  color: #ffffff !important;
}

.stats-card--ios .stats-icon-wrapper {
  background: linear-gradient(135deg, #f5f3ff 0%, #ede9fe 100%) !important;
  box-shadow: 0 4px 12px rgba(168, 85, 247, 0.15) !important;
}

.stats-card--ios:hover .stats-icon-wrapper {
  background: linear-gradient(135deg, #a855f7 0%, #9333ea 100%) !important;
  box-shadow: 0 8px 16px rgba(168, 85, 247, 0.25) !important;
}

.stats-card--ios .stats-icon {
  color: #a855f7 !important;
}

.stats-card--ios:hover .stats-icon {
  color: #ffffff !important;
}

.stats-card--android .stats-icon-wrapper {
  background: linear-gradient(135deg, #ecfdf5 0%, #d1fae5 100%) !important;
  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.15) !important;
}

.stats-card--android:hover .stats-icon-wrapper {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%) !important;
  box-shadow: 0 8px 16px rgba(16, 185, 129, 0.25) !important;
}

.stats-card--android .stats-icon {
  color: #10b981 !important;
}

.stats-card--android:hover .stats-icon {
  color: #ffffff !important;
}

.stats-card:hover .stats-icon-wrapper {
  transform: scale(1.1) rotate(5deg) !important;
}

.stats-icon {
  font-size: 1.3rem !important;
  transition: all 0.3s ease !important;
}

.stats-trend {
  margin-top: 20px !important;
  padding-top: 16px !important;
  border-top: 1px solid rgba(0, 0, 0, 0.05) !important;
  display: flex !important;
  align-items: center !important;
  gap: 8px !important;
}

.trend-indicator {
  font-size: 0.9rem !important;
  font-weight: 600 !important;
  padding: 4px 10px !important;
  border-radius: 30px !important;
  display: inline-flex !important;
  align-items: center !important;
  gap: 4px !important;
}

.trend-indicator i {
  font-size: 0.8rem !important;
}

.trend-up {
  background: rgba(34, 197, 94, 0.1) !important;
  color: #16a34a !important;
}

.trend-down {
  background: rgba(239, 68, 68, 0.1) !important;
  color: #dc2626 !important;
}

.trend-period {
  font-size: 0.85rem !important;
  color: #94a3b8 !important;
  font-weight: 500 !important;
}

.stats-card::before {
  content: '' !important;
  position: absolute !important;
  top: 0 !important;
  right: 0 !important;
  width: 150px !important;
  height: 150px !important;
  pointer-events: none !important;
}

.stats-card--total::before {
  background: radial-gradient(circle at top right, rgba(59, 130, 246, 0.03), transparent 70%) !important;
}

.stats-card--linked::before {
  background: radial-gradient(circle at top right, rgba(34, 197, 94, 0.03), transparent 70%) !important;
}

.stats-card--ios::before {
  background: radial-gradient(circle at top right, rgba(168, 85, 247, 0.03), transparent 70%) !important;
}

.stats-card--android::before {
  background: radial-gradient(circle at top right, rgba(16, 185, 129, 0.03), transparent 70%) !important;
}

/* Normalize App Version / Android OS / iOS OS card heights */
.devices-os-card .card-body {
  min-height: 500px;
}

.devices-os-card .flex-grow-1 {
  min-height: 320px !important;
}

/* Fix chart/card jump on short viewport heights */
@media (max-height: 600px) {
  .devices-os-card .card-body {
    min-height: 420px;
  }

  .devices-os-card .flex-grow-1 {
    min-height: 240px !important;
  }
}
</style>
